import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e347b24"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }, "1", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "版本号", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "启用时间（区间）", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "停用时间（区间）", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "启用状态", -1))
const _hoisted_6 = { style: {"margin-top":"20px","background":"#fff","padding":"0 30px 20px","border-radius":"4px"} }
const _hoisted_7 = { class: "serialNumber" }
const _hoisted_8 = ["onClick", "title"]
const _hoisted_9 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_10 = {
  key: 0,
  class: "spot"
}
const _hoisted_11 = {
  key: 1,
  class: "spot status1"
}
const _hoisted_12 = {
  key: 2,
  class: "spot status2"
}
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { style: {"color":"#999"} }
const _hoisted_17 = { class: "buttonBox" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"display":"flex","align-items":"center"},
  class: "edit"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "edit",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.7894737,4 C11.0510822,4 11.2631579,4.24541858 11.2631579,4.50702715 C11.2631579,4.76863572 11.0510822,4.99481398 10.7894737,4.99481398 L5.80430057,4.99481398 C5.36828629,4.99481398 5.01482689,5.34827338 5.01482689,5.78428766 L5.01482689,14.2631579 C5.01482689,14.6991722 5.36828629,14.9984511 5.80430057,14.9984511 L14.2631579,14.9984511 C14.6991722,14.9984511 15.0070067,14.6449917 15.0070067,14.2089774 L15.0070067,9.05263158 C15.0070067,8.79102301 15.2190824,8.57894737 15.4806909,8.57894737 C15.7422995,8.57894737 16,8.79102301 16,9.05263158 L16,14.2631579 C16,15.2223684 15.2223684,16 14.2631579,16 L5.7368421,16 C4.77763157,16 4,15.2223684 4,14.2631579 L4,5.7368421 C4,4.77763157 4.77763157,4 5.7368421,4 L10.7894737,4 Z M15.5711413,4.0258301 C15.745956,4.07158782 15.9187925,4.24417836 15.9645502,4.41899308 C16.0103079,4.59380779 15.9581799,4.7797095 15.8282016,4.90524674 L8.75770163,11.9759134 C8.56242295,12.1711921 8.24581366,12.1711921 8.05053498,11.9759134 C7.8552563,11.7806347 7.81894233,11.4279574 8.01422101,11.2326787 L15.0848877,4.16234533 C15.2104249,4.03220038 15.3963266,3.98007238 15.5711413,4.0258301 Z",
      id: "形状结合",
      fill: "#666"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "编辑")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_Screen = _resolveComponent("Screen")!
  const _component_TableTab = _resolveComponent("TableTab")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Screen, {
      onSearch: _ctx.search,
      subSlot: 5,
      formState: _ctx.formState,
      "onUpdate:formState": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState) = $event))
    }, {
      "1": _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_input, {
          class: "input",
          value: _ctx.formState.version,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.version) = $event)),
          placeholder: "请输入...",
          onKeyup: _withKeys(_ctx.search, ["enter"]),
          allowClear: ""
        }, null, 8, ["value", "onKeyup"])
      ]),
      "2": _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_a_range_picker, {
          value: _ctx.formState.activeTime,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.activeTime) = $event)),
          onKeyup: _withKeys(_ctx.search, ["enter"]),
          valueFormat: "YYYY-MM-DD HH:mm",
          showTime: { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm"
        }, null, 8, ["value", "onKeyup"])
      ]),
      "3": _withCtx(() => [
        _hoisted_4,
        _createVNode(_component_a_range_picker, {
          value: _ctx.formState.downTime,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.downTime) = $event)),
          onKeyup: _withKeys(_ctx.search, ["enter"]),
          valueFormat: "YYYY-MM-DD HH:mm",
          showTime: { format: 'HH:mm' },
          format: "YYYY-MM-DD HH:mm"
        }, null, 8, ["value", "onKeyup"])
      ]),
      "4": _withCtx(() => [
        _hoisted_5,
        _createVNode(_component_a_select, {
          placeholder: "请选择...",
          style: {"width":"100%"},
          value: _ctx.formState.status,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.status) = $event)),
          optionFilterProp: "label",
          allowClear: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: "1" }, {
              default: _withCtx(() => [
                _createTextVNode("使用中")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "0" }, {
              default: _withCtx(() => [
                _createTextVNode("已停用")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "2" }, {
              default: _withCtx(() => [
                _createTextVNode("编辑中")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onSearch", "formState"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createVNode(_component_TableTab, {
          tabName: "模板列表",
          onSearch: _ctx.search,
          onAdd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toDetails())),
          addBtn: _ctx.addBtn,
          columns: _ctx.columns
        }, null, 8, ["onSearch", "addBtn", "columns"]),
        _createVNode(_component_a_table, {
          rowKey: "id",
          columns: _ctx.columns,
          "data-source": _ctx.data,
          pagination: false,
          scroll: _ctx.scroll,
          loading: _ctx.loading,
          size: _ctx.$store.state.batchStyle
        }, {
          serialNumber: _withCtx(({ index }) => [
            _createElementVNode("span", _hoisted_7, _toDisplayString(index + 1), 1)
          ]),
          taskTVersion: _withCtx(({ record }) => [
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.toDetails(record.id)),
                href: "javascript:",
                class: "terminalName",
                title: record.taskTVersion,
                style: {"text-decoration":"underline"}
              }, _toDisplayString(record.taskTVersion), 9, _hoisted_8)
            ])
          ]),
          status: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_9, [
              (record.status == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                : _createCommentVNode("", true),
              (record.status == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : _createCommentVNode("", true),
              (record.status == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                : _createCommentVNode("", true),
              (record.status == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "已停用"))
                : _createCommentVNode("", true),
              (record.status == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "使用中"))
                : _createCommentVNode("", true),
              (record.status == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, "编辑中"))
                : _createCommentVNode("", true)
            ])
          ]),
          taskTitle: _withCtx(({ record }) => [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(record.taskTitle) + " / ", 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(record.taskTCode), 1)
            ])
          ]),
          handle: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_a_button, {
                style: _normalizeStyle({
                  visibility: record.status == 2 ? 'visible' : 'hidden',
                }),
                type: "text",
                class: "firstButton",
                onClick: ($event: any) => (_ctx.toDetails(record.id, 'edit'))
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 2
              }, 1032, ["style", "onClick"]),
              _createElementVNode("span", {
                class: "stick",
                style: _normalizeStyle({
                  visibility: record.status == 2 ? 'visible' : 'hidden',
                })
              }, "|", 4),
              _createVNode(_component_a_button, {
                disabled: record.status == 1,
                type: "text",
                class: "secondButton",
                onClick: ($event: any) => (_ctx.enable(record)),
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(record.status == 1 ? '' : 'enable')
                  }, "启用", 2)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_a_button, {
                disabled: record.status != 2,
                type: "text",
                class: "lastButton",
                onClick: ($event: any) => (_ctx.del(record))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(record.status != 2 ? '' : 'del')
                  }, "删除", 2)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll", "loading", "size"])
      ]),
      _createVNode(_component_Pagination, {
        total: _ctx.total,
        onChange: _ctx.changePagination
      }, null, 8, ["total", "onChange"])
    ])
  ]))
}